<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1">
    <span slot="tab">
      <a-icon type="warning"/>
      Aviso en caso de emergencia
    </span>
      <a-card>
        <div v-if="$getConfigValue('MOSTRAR_ALERTA_BIODATA_EMERGENCIA', 'NO') === 'SI'">
          <a-alert
            :message="$getConfigValue('MENSAJE1_ALERTA_EMERGENCIA')"
            :description="$getConfigValue('MENSAJE2_ALERTA_EMERGENCIA')"
            type="info"
            show-icon
          />
          <br>
        </div>
        <g-master name="biodataaviso"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="evParentData"
                  :beforeSend="master.beforeSend"
                  @action="masterAction"
                  modalWidth="70%"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Nombre completo')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['fullname', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :formItemConfig="fiOptions"
                            :label="$t('Género')"
                            :decorator="['gender', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="sexo">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :formItemConfig="fiOptions"
                            :label="$t('Parentesco')"
                            :decorator="['id_h_relationship', { rules: [{ required: false }] }]"
                            :params="id_h_relationship">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :formItemConfig="fiOptions"
                            :label="$t('Departamento')"
                            :decorator="['id_h_state', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="{h_lookup_type: 'DEPARTAMENTOS'}">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup endpoint="hierarchy_lookup"
                            :formItemConfig="fiOptions"
                            :label="$t('Ciudad')"
                            :decorator="['id_h_city', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="{h_lookup_type: 'CIUDADES'}"
                            ref="city"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Dirección')">
                  <a-textarea placeholder="Dirección"
                              class="ant-uppercase"
                              readOnly
                              autoSize
                              v-model="address"
                              v-on:click="modalDireccionVisible = true">
                  </a-textarea>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Teléfono')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['telephone', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Celular')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['cellphone', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Email')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['email', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-card>
      </a-tab-pane>
    </a-tabs>
    <direccion-estructurada v-model="address" :visible="modalDireccionVisible"
                            @cancel="modalDireccionVisible = false"
                            @success="direccionCambiada"></direccion-estructurada>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        address: null,
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        modalDireccionVisible: false,
        localizacion: {
          departamento: {},
          ciudad: {}
        },
        colOptions: {xs: 24, sm: 12},
        id_h_relationship: {
          h_lookup_type: 'PARENTESCO'
        },
        id_h_city_birth: {
          h_lookup_type: 'CIUDADES'
        },
        id_h_blood_group: {
          h_lookup_type: 'GRUPO_SANGUINEO'
        },
        id_h_blood_rh: {
          h_lookup_type: 'RH'
        },
        sexo: {
          h_lookup_type: 'SEXO',
          use_code: true
        },
        master: {
          beforeSend: (data) => {
            data.address = this.address
            return data
          },
          endpoint: 'personemergency',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_emergency'
            },
            columns: [
              {title: 'Nombre completo', dataIndex: 'fullname', sorter: true},
              {title: 'Dirección', dataIndex: 'address', sorter: true},
              {title: 'Género', dataIndex: 'genero', sorter: true},
              {title: 'Ciudad', dataIndex: 'h_city', sorter: true},
              {title: 'Estado civil', dataIndex: 'h_state', sorter: true},
              {title: 'Teléfono', dataIndex: 'telephone', sorter: true},
              {title: 'Celular', dataIndex: 'cellphone', sorter: true},
              {title: 'Parentesco', dataIndex: 'h_relationship', sorter: true},
              {title: 'Email', dataIndex: 'email', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado el', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ]
          },
          modalFieldsSetup: [
            {name: 'fullname'},
            {name: 'address'},
            {name: 'gender'},
            {name: 'id_h_city'},
            {name: 'id_h_state'},
            {name: 'telephone'},
            {name: 'cellphone'},
            {name: 'id_h_relationship'},
            {name: 'email', type: 'email'}
          ]
        }
      }
    },
    props: ['persona'],
    methods: {
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.address = ''
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.address)) {
              this.address = action.record.address
            }
            if (!JsUtils.isEmpty(action.record.id_h_city)) {
              this.$refs.city && this.$refs.city.handleSearch(action.record.id_h_city)
            }
            break
        }
      }
    },
    computed: {
      evParentData () {
        return {
          id_person: this.persona
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataAvisoEnCasoEmergencia.vue